import { useId, useImperativeHandle, useRef } from 'react';
import type { Ref, RefObject } from 'react';

import type { RadioGroupHandle } from 'ui/radio-group/radio-group.types';

const FOCUS_ORDER = [
  'input:not(:disabled):checked',
  'input:not(:disabled)',
] as const;

interface UseRadioGroupArgs {
  ref?: Ref<RadioGroupHandle>;
  hasLabel: boolean;
  hasHelperText: boolean;
}

export interface UseRadioGroupResult {
  optionsRef: RefObject<HTMLDivElement | null>;
  labelId?: string;
  helperTextId?: string;
}

export const useRadioGroup = ({
  ref,
  hasLabel,
  hasHelperText,
}: UseRadioGroupArgs): UseRadioGroupResult => {
  const optionsRef = useRef<HTMLDivElement>(null);
  const id = useId();

  useImperativeHandle(
    ref,
    () => ({
      focus: () => {
        const options = optionsRef.current;
        const target = FOCUS_ORDER.map((selector) =>
          options?.querySelector<HTMLInputElement>(selector)
        ).find(Boolean);

        target?.focus();
      },
    }),
    []
  );

  return {
    optionsRef,
    labelId: hasLabel ? `${id}-label` : undefined,
    helperTextId: hasHelperText ? `${id}-helper-text` : undefined,
  };
};
